//import {defaultStaticRanges} from 'react-date-range';
import {defaultStaticRanges} from './defaultRangesLocales';

const defaultStaticsRangeLocales = (language = "es") => {
    const locales = {
        "es": {
            "Today": "Hoy",
            "Yesterday": "Ayer",
            "This Week": "Esta semana",
            "Last Week": "La semana pasada",
            "This Month": "Este mes",
            "Last Month": "El mes pasado",
        }
    }
    if (language !== "en") {
        if (!(language in locales)){
            return defaultStaticRanges;
        }
        let i;
        for (i=0; i<defaultStaticRanges.length; i++) {
            if(defaultStaticRanges[i].locale && defaultStaticRanges[i].locale === language){
                break;
            }
            defaultStaticRanges[i].label = locales[language][defaultStaticRanges[i].label];
            defaultStaticRanges[i].locale = language;
        }
    }
    return defaultStaticRanges;
}
export default defaultStaticsRangeLocales